<rlst-header *ngIf="isLoggedIn$ | async" [isDashboardRoute]="isDashboardRoute | async"
    [isPropertyIntelRoute]='isPropertyIntelRoute$ | async' [isNewTheme]="isNewTheme$ | async">
</rlst-header>
<!--End testing-->
<router-outlet></router-outlet>
<rlst-spinner (cancelRequest)="cancelRequest()"></rlst-spinner>
